import React, { useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authAPI, setStoredToken } from '../utils/api';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        const hash = location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          navigate('/login');
          return;
        }

        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const sessionId = sessionIdMatch[1];
        const response = await authAPI.createSession(sessionId);
        if (response.data?.session_token) setStoredToken(response.data.session_token);
        setUser(response.data);
        
        // Redirect to complete-profile if phone not verified, else dashboard
        const dest = response.data.phone_verified ? '/dashboard' : '/complete-profile';
        navigate(dest, { state: { user: response.data } });
      } catch (error) {
        console.error('Session processing failed:', error);
        navigate('/login');
      }
    };

    processSession();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-[#1800ad] mx-auto mb-4"></div>
        <p className="text-[#4B5563] font-medium">Authenticating...</p>
      </div>
    </div>
  );
};

export default AuthCallback;